const departments = {
    finance: 'Finance',
    marketing: 'Marketing',
    engineering: 'Engineering',
    humanResources: 'Human Resources',
    sales: 'Sales',
    operations: 'Operations',
    legal: 'Legal',
    executive: 'Executive',
  };

export default departments;
